<template>
  <div class="design-home">
    <navBarNoLab :onIndex="5" />
    <!-- 背景部分 -->
    <designBackground :backGroundCom="backGroundComInfo">
      <template #navList>
        <pageElement :onIndex="5" />
      </template>
    </designBackground>
    <!-- 项目专栏 -->
    <specialColumn />
    <!-- 设计的项目 丰富多彩 -->
    <richColorful />
    <!-- 项目的教学 全面、严谨且强悍 -->
    <teachCompre />
    
    <!-- footer -->
    <bottomWidge />
  </div>
</template>

<script>
import navBarNoLab from "@/views/components/navBarNoLab"
import designBackground from "./components/designBackground"
import richColorful from "./components/richColorful"
import teachCompre from "./components/teachCompre"
import specialColumn from "./components/specialColumn"
import bottomWidge from "@/views/components/bottomWidge"
// 导航抽离
import pageElement from "../common/pageElement"

export default {
  name: "homeDesign",
  components: {
    navBarNoLab,
    designBackground,
    richColorful,
    teachCompre,
    specialColumn,
    bottomWidge,
    pageElement
  },
  data () {
    return {
      backGroundComInfo: {
        onIndex: 5,
        title: "设计学科",
        titlep1: "历经八年教学积淀 打造众多出色项目",
        titlep2: "设计驱动创新 实现商业价值"
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .design-home {
    // background-color: #fff;
    width: 100%;
  }
</style>